
  import {Component, Vue} from "vue-property-decorator";
  import breadcrumb from "@/components/common/breadcrumb.vue";
  import {getLatestItemInfo, updateAuditInfo, showCountGroupByCountry} from '@/services/api';

  @Component({
    components: {'zf-breadcrumb': breadcrumb},
  })
  export default class ItemList extends Vue {
    // 面包屑导航
    public navList: { name: string, to?: string }[] = [
      {name: '最近50条未审核item列表'}
    ]
    // 控制列表高度
    public tableHeight: number = window.innerHeight - 240;
    // 地区
    public country = '';
    public countryList: string[] = ['HK', 'JP', 'MY', 'SG', 'TH', 'TW', 'US'];
    // 语言
    public language = '';
    public languageList: string[] = ['zh', 'en', 'th', 'jp'];
    // 列表数据
    public tableData: {
      adId: number,
      body: string,
      country: string,
      images: string[],
      itemId: number,
      copiedItemId: number,
      language: string,
      linkUrl: string,
      tempLinkUrl: string,
      title: string,
      video: string,
      videoPreview: string,
      status?: string,
      reason?: string
    }[] = [];
    // 今日分地区已上传审核通过的数量
    public todayAuditList: {country: string, passed: number, count: number}[] = [];

    /**
     * 初始化方法
     */
    created(): void {
      this.getLatestItemInfo();
      window.onresize = () => {
        try {
          this.tableHeight = window.innerHeight - 240;
        } catch (e) {}
      }
    }

    /**
     * 获取实验列表
     */
    getLatestItemInfo(): void {
      getLatestItemInfo(this.country, this.language, true)
        .then(res => {
          if (res.data && res.data.result) {
            this.tableData = res.data.result;
          } else {
            this.tableData = [];
          }
          this.showCountGroupByCountry();
        }).catch(() => {})
    }


    /**
     * 打开新的窗口
     */
    openWindow(url: string): void {
      window.open(url,'_blank')
    }

    /**
     * 今日已审核item数量
     */
    showCountGroupByCountry(): void {
      showCountGroupByCountry()
        .then(res => {
          if (res.data && res.data.result) {
            this.todayAuditList = res.data.result;
          }
        })
    }

    /**
     * 输入审核状态和不通过原因（v-model有效率问题，弃用）
     */
    input(e: any, item: any, key: string): void {
      item[key] = e.target.value;
    }

    /**
     * 提交审核状态
     */
    submit() {
      const auditList: { itemId: number, status: string, reason?: string }[] = [];
      for (let item of this.tableData) {
        if (item.status) {
          auditList.push({
            itemId: item.itemId,
            status: item.status,
            reason: item.reason
          })
        }
      }

      if (auditList.length === 0) {
        this.$message.warning('没有可以提交的审核');
        return;
      }

      console.log(auditList);

      const params = {json: JSON.stringify(auditList)}
      updateAuditInfo(params, true)
        .then(res => {
          if (res.data && res.data.message === 'Success') {
            this.$message.success('提交成功');
            this.getLatestItemInfo();
          } else {
            this.$message.error('提交失败，清稍后重试');
          }
        })
        .catch(() => {})
    }

  }

